// DriverSidebar.jsx
import NestedMenu from "components/Shared/NestedMenu";
import React from "react";

const CustomerSidebar = () => {
  const menuItems = [
    {
      title: "Dashboard",
      path: "/app/customer/dashboard",
      icon: "DashboardOutlined",
    },
    {
      title: "Shipment",
      path: "/app/customer/customer-shipment",
      icon: "LocalShippingOutlined",
    },
    {
      title: "Announcement",
      path: "/app/customer/announcement/list",
      icon: "CampaignOutlined",
    },
    // {
    //     title: "History",
    //     path: "/app/customer/history",
    //     icon: "ScheduleOutlined"
    // },
    // {
    //     title: "Chat",
    //     path: "/app/customer/customer-chat",
    //     icon: "ChatBubbleOutlineOutlined"
    // },
  ];

  return <NestedMenu menu={menuItems} initiallyOpenedMenu="Males" />;
};

export default CustomerSidebar;
